import { render, staticRenderFns } from "./real.vue?vue&type=template&id=4e631828&scoped=true&"
import script from "./real.vue?vue&type=script&lang=js&"
export * from "./real.vue?vue&type=script&lang=js&"
import style0 from "./real.vue?vue&type=style&index=0&id=4e631828&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e631828",
  null
  
)

export default component.exports